import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Loader from '../jsx/components/Loader/Loader';
import { fetchScreenPermission, showPermissionDeniedPopup } from '../utils/permissions';

const ProtectedRoute = ({ screenCode, children }) => {
  const authState = useSelector((s) => s.auth);
  const userId = authState?.auth?.ID || authState?.auth?.id || authState?.auth?.localId;
  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;
    async function check() {
      if (!screenCode) {
        if (mounted) {
          setAllowed(true);
          setLoading(false);
        }
        return;
      }

      if (!userId) {
        showPermissionDeniedPopup('User not identified');
        navigate('/page-error-403');
        return;
      }

      const res = await fetchScreenPermission(screenCode, userId);

      const table = res?.Table || res?.data?.Table || null;
      const noDataError = res?.error?.Message === 'No Data Available' || res?.error?.Message === 'Not Found' || res?.data === null;
      if (mounted) {
        if (res?.error && noDataError) {
          showPermissionDeniedPopup('आपके पास अनुमति नहीं है');
          setAllowed(false);
          setLoading(false);
          navigate('/page-error-403');
          return;
        }

        if (res?.error && !noDataError) {
          
          showPermissionDeniedPopup(res.error?.Message || res.error || 'Permission check failed');
          setAllowed(false);
          setLoading(false);
          navigate('/page-error-403');
          return;
        }

       
        if (table && Array.isArray(table) && table.length > 0) {
          setAllowed(true);
          setLoading(false);
          return;
        }

       
        const hasSomeData = res && typeof res === 'object' && Object.keys(res).length > 0 && !noDataError;
        if (hasSomeData) {
          setAllowed(true);
          setLoading(false);
          return;
        }

        showPermissionDeniedPopup('आपके पास अनुमति नहीं है');
        setAllowed(false);
        setLoading(false);
        navigate('/page-error-403');
        return;
      }
    }
    check();
    return () => { mounted = false; };
  }, [screenCode, userId, navigate]);

  if (loading) return <Loader />;
  if (!allowed) return null;
  return <>{children}</>;
};

export default ProtectedRoute;
